import { AfterViewInit, Component } from '@angular/core'
import { HeaderComponent } from '../header/header.component'
import { FormMarketingDeskComponent } from '../form-marketing-desk/form-marketing-desk.component'
import { MatButtonModule } from '@angular/material/button'
import { ActivatedRoute, RouterLink, Router } from '@angular/router'
import { CommonModule, Location } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SrecFormService } from '../services/srec-form.service'

@Component({
  selector: 'app-register-srec',
  standalone: true,
  imports: [
    HeaderComponent,
    FormMarketingDeskComponent,
    MatButtonModule,
    RouterLink,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
  ],
  templateUrl: './register-srec.component.html',
  styleUrl: './register-srec.component.scss',
})
export class RegisterSrecComponent implements AfterViewInit {
  showForm = false
  showPrereq = true
  isOwnerControl = new FormControl('')
  isinstallerControl = new FormControl('')
  referralSource = new FormControl<string | null>(null)
  propertyType = new FormControl<string | null>('', Validators.required)
  showMainForm: boolean = false
  failSection: boolean = false
  isSubmitting: boolean = false
  submitError: string | null = null
  contractFileName: string | null = null
  contractFile: File | null = null
  showErrors = false

  ineligibleForm = new FormGroup({
    fullName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{10}$'),
    ]),
    streetAddress: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),
    zipcode: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{5}$'),
    ]),
    contractFile: new FormControl(''),
  })

  onNext() {
    this.showErrors = true
    if (this.propertyType.valid) {
      this.handlePath()
    } else {
      this.propertyType.markAsTouched() // Trigger error display
    }
  }

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private srecFormService: SrecFormService
  ) {}

  handlePath(): void {
    console.log('Property Type:', this.propertyType.value)
    console.log('Owner Control:', this.isOwnerControl.value)

    if (
      this.isOwnerControl.value === 'no' &&
      this.propertyType.value === 'Residential'
    ) {
      this.failSection = true
      return
    }

    if (
      this.propertyType.value === 'Commercial / Industrial' ||
      this.propertyType.value === 'Other'
    ) {
      console.log('Navigating to commercial route')
      this.router.navigate(['/register/commercial'], {
        queryParams: {
          referralSource: this.referralSource.value,
          isExistingInstaller: this.isinstallerControl.value === 'yes',
        },
      })
      return
    }

    if (this.propertyType.value === 'Spruce Existing Partner') {
      console.log('Navigating to commercial route for residential partner')
      this.router.navigate(['/register/commercial'], {
        queryParams: {
          referralSource: this.referralSource.value,
          isExistingResidentialPartner: true,
        },
      })
      return
    }

    this.showMainForm = true
  }

  returnToRegisterSection(): void {
    this.showMainForm = false
    this.showForm = false
  }

  back(): void {
    this.router.navigate(['/'])
  }

  onContractFileChange(event: any): void {
    const file = event.target.files[0]
    if (file) {
      // Validate file type
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]
      if (allowedTypes.includes(file.type)) {
        this.contractFile = file
        this.contractFileName = file.name
        this.ineligibleForm.patchValue({ contractFile: file })
      } else {
        alert('Please upload only PDF or Word document files.')
        event.target.value = ''
        this.contractFile = null
        this.contractFileName = null
      }
    }
  }

  submitIneligibleForm(): void {
    if (this.ineligibleForm.invalid) {
      return
    }

    this.isSubmitting = true
    this.submitError = null

    // Create FormData to handle file upload
    const formData = new FormData()
    formData.append(
      'fullName',
      this.ineligibleForm.get('fullName')?.value || ''
    )
    formData.append('email', this.ineligibleForm.get('email')?.value || '')
    formData.append(
      'phoneNumber',
      this.ineligibleForm.get('phoneNumber')?.value || ''
    )
    formData.append(
      'streetAddress',
      this.ineligibleForm.get('streetAddress')?.value || ''
    )
    formData.append('city', this.ineligibleForm.get('city')?.value || '')
    formData.append('state', this.ineligibleForm.get('state')?.value || '')
    formData.append('zipcode', this.ineligibleForm.get('zipcode')?.value || '')

    if (this.contractFile) {
      formData.append('contractFile', this.contractFile)
    }

    this.srecFormService.postIneligibleRegistration(formData).subscribe({
      next: () => {
        this.isSubmitting = false
        this.router.navigate(['/'])
      },
      error: (error: any) => {
        this.isSubmitting = false
        this.submitError = 'Failed to submit form. Please try again later.'
        console.error('Form submission error:', error)
      },
    })
  }

  ngAfterViewInit() {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        const element = document.getElementById(fragment)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
    })
  }
}
